export const userMediaAvailable = () => {
  return (
    navigator.mediaDevices ||
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (navigator as any).mozGetUserMedia ||
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (navigator as any).webkitGetUserMedia
  );
};
